import { Link } from 'react-router-dom'

// Top-bar breadcrumb for the current page (Sidebar Navigation Spec §1). Every
// crumb but the last links; the last carries `aria-current="page"`.
export function Breadcrumb({ crumbs, testId }: { crumbs: Array<{ label: string; to?: string }>; testId?: string }) {
  return (
    <nav aria-label="Breadcrumb" className="qz-crumbs" data-testid={testId}>
      {crumbs.map((c, i) => {
        const last = i === crumbs.length - 1
        return (
          <span key={i} className="qz-crumb">
            {i > 0 && <span className="qz-crumb-sep" aria-hidden="true">›</span>}
            {c.to && !last ? (
              <Link to={c.to}>{c.label}</Link>
            ) : (
              <span aria-current={last ? 'page' : undefined}>{c.label}</span>
            )}
          </span>
        )
      })}
    </nav>
  )
}
